module.exports = __webpack_public_path__ + "static/media/facebook.c466584b.svg";